import React, { useCallback } from 'react';
import { Select, Button, Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { Option } = Select;

export interface FlowSelectorProps {
  flowOptions: { label: string; value: string }[];
  selectedFlows: string[];
  onSelectionChange: (selectedFlowIdentifiers: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  loading?: boolean;
}

export const FlowSelector: React.FC<FlowSelectorProps> = ({
  flowOptions,
  selectedFlows,
  onSelectionChange,
  disabled = false,
  placeholder = 'Select flows...',
  loading = false,
}) => {
  const handleSelectionChange = useCallback(
    (values: string[]) => {
      onSelectionChange(values);
    },
    [onSelectionChange],
  );

  const handleClear = useCallback(() => {
    onSelectionChange([]);
  }, [onSelectionChange]);

  if (loading) {
    return (
      <Button disabled size="small">
        Loading flows...
        <Spin size="small" />
      </Button>
    );
  }

  if (flowOptions.length === 0) {
    return (
      <Button disabled size="small">
        No flows available
        <DownOutlined />
      </Button>
    );
  }

  return (
    <Select
      mode="multiple"
      placeholder={placeholder}
      value={selectedFlows}
      onChange={handleSelectionChange}
      disabled={disabled}
      loading={loading}
      allowClear
      showSearch
      optionFilterProp="label"
      style={{ width: '150px' }}
      dropdownStyle={{ maxHeight: 300, width: 'fit-content' }}
      maxTagCount="responsive"
      onClear={handleClear}
      size="small"
    >
      {flowOptions.map((option) => (
        <Option key={option.value} value={option.value} label={option.label}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default FlowSelector;
